/* eslint-disable max-lines */
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioArchIo } from './pages'

type TIdToPageMap = Record<PageIdStylioArchIo, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_ARCH_IO: TIdToPageMap = {
  [PageIdStylioArchIo.AGE_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/AgeQuestion'),
  },
  [PageIdStylioArchIo.SHOP_SMARTER_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/shop-smarter/ShopSmarter'
      ).then((m) => ({
        default: m.ShopSmarter,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/shop-smarter/ShopSmarter'),
  },
  [PageIdStylioArchIo.HAIR_COLOR_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioArchIo.WARDROBE_COLORS_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeColorsQuestion'
      ).then((m) => ({
        default: m.WardrobeColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeColorsQuestion'
      ),
  },
  [PageIdStylioArchIo.COLOR_CONFIDENCE_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ColorConfidenceQuestion'
      ).then((m) => ({
        default: m.ColorConfidenceQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ColorConfidenceQuestion'
      ),
  },
  [PageIdStylioArchIo.EYES_COLOR_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioArchIo.SKIN_COLOR_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/SkinColorQuestion'
      ).then((m) => ({
        default: m.SkinColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/SkinColorQuestion'),
  },
  [PageIdStylioArchIo.CLIMAT_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ClimatQuestion'
      ).then((m) => ({
        default: m.ClimatQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/ClimatQuestion'),
  },
  [PageIdStylioArchIo.BODY_SHAPE_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioArchIo.BODY_SHAPE_CONFIDENCE_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/BodyShapeConfidenceQuestion'
      ).then((m) => ({
        default: m.BodyShapeConfidenceQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/BodyShapeConfidenceQuestion'
      ),
  },
  [PageIdStylioArchIo.SHOW_OFF_FEATURES_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ShowOffFeaturesQuestion'
      ).then((m) => ({
        default: m.ShowOffFeaturesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ShowOffFeaturesQuestion'
      ),
  },
  [PageIdStylioArchIo.STYLIO_TO_HELP_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/StylioToHelp'),
  },
  [PageIdStylioArchIo.MAIN_GOAL_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/MainGoalQuestion'
      ).then((m) => ({
        default: m.MainGoalQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/MainGoalQuestion'),
  },
  [PageIdStylioArchIo.WHERE_TO_SHOP_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WhereToShopQuestion'
      ).then((m) => ({
        default: m.WhereToShopQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WhereToShopQuestion'
      ),
  },
  [PageIdStylioArchIo.WARDROBE_PERCENTAGE_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobePercentageQuestion'
      ).then((m) => ({
        default: m.WardrobePercentageQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobePercentageQuestion'
      ),
  },
  [PageIdStylioArchIo.URGE_1_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant1').then(
        (m) => ({
          default: m.UrgePageVariant1,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant1'),
  },
  [PageIdStylioArchIo.URGE_2_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioArchIo.URGE_3_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioArchIo.URGE_9_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant9').then(
        (m) => ({
          default: m.UrgePageVariant9,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant9'),
  },
  [PageIdStylioArchIo.URGE_4_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioArchIo.URGE_5_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant5').then(
        (m) => ({
          default: m.UrgePageVariant5,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant5'),
  },
  [PageIdStylioArchIo.URGE_6_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant6').then(
        (m) => ({
          default: m.UrgePageVariant6,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant6'),
  },
  [PageIdStylioArchIo.STYLE_PROFILE_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/StyleProfilePage').then(
        (m) => ({
          default: m.StyleProfilePage,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/StyleProfilePage'),
  },
  [PageIdStylioArchIo.WARDROBE_READY_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeReadyQuestion'
      ).then((m) => ({
        default: m.WardrobeReadyQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeReadyQuestion'
      ),
  },
  [PageIdStylioArchIo.URGE_7_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant7').then(
        (m) => ({
          default: m.UrgePageVariant7,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant7'),
  },
  [PageIdStylioArchIo.URGE_8_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant8').then(
        (m) => ({
          default: m.UrgePageVariant8,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/urge/UrgePageVariant8'),
  },
  [PageIdStylioArchIo.STYLE_DRAWN_TO_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/StyleDrawnToQuestion'
      ).then((m) => ({
        default: m.StyleDrawnToQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/StyleDrawnToQuestion'
      ),
  },
  [PageIdStylioArchIo.OUTFIT_EMOTION_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/OutfitEmotionQuestion'
      ).then((m) => ({
        default: m.OutfitEmotionQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/OutfitEmotionQuestion'
      ),
  },
  [PageIdStylioArchIo.STYLE_DISCOVERY_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/StyleDiscoveryQuestion'
      ).then((m) => ({
        default: m.StyleDiscoveryQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/StyleDiscoveryQuestion'
      ),
  },
  [PageIdStylioArchIo.NOTHING_TO_WEAR_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioArchIo.ARCHETYPE_INTRO_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/ArchetypeIntro'
      ).then((m) => ({
        default: m.ArchetypeIntro,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/archetype/ArchetypeIntro'),
  },
  [PageIdStylioArchIo.DRESSED_FEEL_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/DressedFeelQuestion'
      ).then((m) => ({
        default: m.DressedFeelQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/DressedFeelQuestion'
      ),
  },
  [PageIdStylioArchIo.STYLE_MATTERS_MOST_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/StyleMattersMostQuestion'
      ).then((m) => ({
        default: m.StyleMattersMostQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/StyleMattersMostQuestion'
      ),
  },
  [PageIdStylioArchIo.OUTFIT_VIBE_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/OutfitVibeQuestion'
      ).then((m) => ({
        default: m.OutfitVibeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/archetype/OutfitVibeQuestion'),
  },
  [PageIdStylioArchIo.OUTFIT_COMPLIMENT_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/OutfitComplimentQuestion'
      ).then((m) => ({
        default: m.OutfitComplimentQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/OutfitComplimentQuestion'
      ),
  },
  [PageIdStylioArchIo.SHOP_PULLS_FIRST_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/ShopPullsFirstQuestion'
      ).then((m) => ({
        default: m.ShopPullsFirstQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/ShopPullsFirstQuestion'
      ),
  },
  [PageIdStylioArchIo.ARCHETYPE_LOADING_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/ArchetypeLoading'
      ).then((m) => ({
        default: m.ArchetypeLoading,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/archetype/ArchetypeLoading'),
  },
  [PageIdStylioArchIo.ARCHETYPE_RESULT_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/archetype/ArchetypeResult'
      ).then((m) => ({
        default: m.ArchetypeResult,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/archetype/ArchetypeResult'),
  },
  [PageIdStylioArchIo.LOOKING_FEMININE_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/LookingFeminineQuestion'
      ).then((m) => ({
        default: m.LookingFeminineQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/LookingFeminineQuestion'
      ),
  },
  [PageIdStylioArchIo.STYLES_FEEL_LIKE_YOU_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/StylesFeelLikeYouQuestion'
      ).then((m) => ({
        default: m.StylesFeelLikeYouQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/StylesFeelLikeYouQuestion'
      ),
  },
  [PageIdStylioArchIo.TALL_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/TallQuestion'),
  },
  [PageIdStylioArchIo.WEIGHT_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/WeightQuestion'),
  },
  [PageIdStylioArchIo.WARDROBE_CHANGED_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeChangedQuestion'
      ).then((m) => ({
        default: m.WardrobeChangedQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeChangedQuestion'
      ),
  },
  [PageIdStylioArchIo.FAVORITE_COLORS_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_11_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant11ArchIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant11ArchIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant11ArchIo'
      ),
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_14_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant14ArchIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant14ArchIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant14ArchIo'
      ),
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_15_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant15ArchIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant15ArchIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant15ArchIo'
      ),
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_18_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant18ArchIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant18ArchIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant18ArchIo'
      ),
  },
  [PageIdStylioArchIo.LIKE_OR_DISLIKE_19_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant19ArchIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant19ArchIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/likeOrDislike/LikeOrDislikeVariant19ArchIo'
      ),
  },
  [PageIdStylioArchIo.WALK_INTO_ROOM_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WalkIntoRoomQuestion'
      ).then((m) => ({
        default: m.WalkIntoRoomQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WalkIntoRoomQuestion'
      ),
  },
  [PageIdStylioArchIo.PERFECT_WEEKEND_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/PerfectWeekendQuestion'
      ).then((m) => ({
        default: m.PerfectWeekendQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/PerfectWeekendQuestion'
      ),
  },
  [PageIdStylioArchIo.WARDROBE_FEEL_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeFeelQuestion'
      ).then((m) => ({
        default: m.WardrobeFeelQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeFeelQuestion'
      ),
  },
  [PageIdStylioArchIo.SHOPPING_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioArchIo.SHOPPING_BUDGET_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ShoppingBudgetQuestion'
      ).then((m) => ({
        default: m.ShoppingBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ShoppingBudgetQuestion'
      ),
  },
  [PageIdStylioArchIo.SHOPPING_PRIORITY_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ShoppingPriorityQuestion'
      ).then((m) => ({
        default: m.ShoppingPriorityQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/ShoppingPriorityQuestion'
      ),
  },
  [PageIdStylioArchIo.CURATED_LINKS_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/CuratedLinksQuestion'
      ).then((m) => ({
        default: m.CuratedLinksQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/CuratedLinksQuestion'
      ),
  },
  [PageIdStylioArchIo.LIFESTYLE_FOCUS_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/LifestyleFocusQuestion'
      ).then((m) => ({
        default: m.LifestyleFocusQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/LifestyleFocusQuestion'
      ),
  },
  [PageIdStylioArchIo.OUTFIT_NEEDS_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/OutfitNeedsQuestion'
      ).then((m) => ({
        default: m.OutfitNeedsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/OutfitNeedsQuestion'
      ),
  },
  [PageIdStylioArchIo.WARDROBE_ALIGNS_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeAlignsQuestion'
      ).then((m) => ({
        default: m.WardrobeAlignsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/WardrobeAlignsQuestion'
      ),
  },
  [PageIdStylioArchIo.LIFESTYLE_CHANGES_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/LifestyleChangesQuestion'
      ).then((m) => ({
        default: m.LifestyleChangesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/LifestyleChangesQuestion'
      ),
  },
  [PageIdStylioArchIo.AMAZON_FRUSTRATION_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/AmazonFrustrationQuestion'
      ).then((m) => ({
        default: m.AmazonFrustrationQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/questions/AmazonFrustrationQuestion'
      ),
  },
  [PageIdStylioArchIo.PREPARE_FLOW_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioArchIo.EMAIL_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_arch_io/pages/email/Email'),
  },
  [PageIdStylioArchIo.EMAIL_CONSENT_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/email/EmailConsent'),
  },
  [PageIdStylioArchIo.NAME_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/name/Name').then((m) => ({
        default: m.Name,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_arch_io/pages/name/Name'),
  },
  [PageIdStylioArchIo.READINESS_LEVEL_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/readinessLevel/ReadinessLevel'
      ).then((m) => ({
        default: m.ReadinessLevel,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/readinessLevel/ReadinessLevel'
      ),
  },
  [PageIdStylioArchIo.PRE_PAYWALL_OFFER_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/prePaywallOffer/PrePaywallOffer'
      ).then((m) => ({
        default: m.PrePaywallOffer,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/prePaywallOffer/PrePaywallOffer'
      ),
  },
  [PageIdStylioArchIo.SUBSCRIPTIONS_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioArchIo.CANCEL_OFFER_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioArchIo.AI_STYLIST_UPSELL_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/sub-upsell/AiStylistUpsell'
      ).then((m) => ({
        default: m.AiStylistUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/sub-upsell/AiStylistUpsell'),
  },
  [PageIdStylioArchIo.SUB_UPSELL_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioArchIo.UPSELL_ARCH_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_arch_io/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_arch_io/pages/upsell/Upsell'),
  },
  [PageIdStylioArchIo.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioArchIo.DOWNLOAD_ARCH_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_arch_io/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_arch_io/pages/download-app/DownloadDefault'),
  },
}
